import { probeMimeBytes } from "@/infrastructure/di";

type ProbeMimeBytes = (url: string, probeBytes: number) => Promise<Uint8Array | null>;

export function useMimeProbe(): ProbeMimeBytes {
  return probeMimeBytes;
}
